import { useComprehensiveTopNav } from 'hooks';
import React from 'react';
import { Redirect, Switch, useRouteMatch } from 'react-router-dom';
import SuperAdminRoute from 'routes/super-admin';
import CostAmplifierTab from './CostAmplifierTab';
import classes from './index.module.scss';
import ServicesTab from './ServicesTab';
import Tab from './Tab';
import GeneralTab from './GeneralTab';

/**
 * Props interface for the SettingsScreen component
 * Currently empty as the component doesn't require any props
 */
interface Props {}

/**
 * Settings screen component
 * Provides a tabbed interface for managing various system settings
 * All tabs are protected by SuperAdminRoute to ensure only super admins can access them
 *
 * @returns {JSX.Element} - Rendered component
 */
const SettingsScreen = ({}: Props) => {
	// Route matching for nested routes
	const { url, path } = useRouteMatch();
	// Set up the top navigation bar with title and notification icon
	useComprehensiveTopNav('Settings', { notificationVisible: true });

	return (
		<div className={classes['settings']}>
			{/* Tab navigation sidebar */}
			<div className={classes['settings-tabs']}>
				{/* General settings tab */}
				<Tab iconSrc="icTax" label="General" to={`${url}/general`} />
				{/* Cost amplifiers management tab */}
				<Tab iconSrc="icCostAmp" label="Custom Cost Amplifiers" to={`${url}/cost-amplifier`} />
				{/* Services management tab */}
				<Tab iconSrc="icServices" label="Services" to={`${url}/services`} />
			</div>
			{/* Tab content area */}
			<div className={classes['settings-tabBody']}>
				<Switch>
					{/* Each route is protected by SuperAdminRoute to ensure only super admins can access */}
					<SuperAdminRoute exact path={`${path}/general`} component={GeneralTab} />
					<SuperAdminRoute exact path={`${path}/cost-amplifier`} component={CostAmplifierTab} />
					<SuperAdminRoute exact path={`${path}/services`} component={ServicesTab} />
					{/* Default redirect to general tab */}
					<Redirect to={`${path}/general`} />
				</Switch>
			</div>
		</div>
	);
};

export default SettingsScreen;
